//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import UserHistoryList from './list';

export const FilterUserHistory = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[2] !== "user_history") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterUserHistory.Provider value={{ filter, setFilter }}>
      <Route path="/premixapp/user_history" exact component={UserHistoryList} isPrivate/>
    </FilterUserHistory.Provider>
  )
}